(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drops-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The marquee uses a pure CSS animation that never pauses — we
    // intentionally do NOT attach any touch/hover handlers so the loop
    // keeps running continuously per the design spec.

    // Pixel-perfect loop: translate by the EXACT integer width of one card
    // set (offsetWidth is already flex-rounded to whole pixels) so the wrap
    // aligns on the identical duplicate with no sub-pixel shimmer.
    function setMarqueeShift() {
      document.querySelectorAll('[data-drops-marquee-track]').forEach(function (track) {
        var cards = track.querySelectorAll('.drops-landing__product-card');
        var half = Math.floor(cards.length / 2);
        if (half < 1) return;
        var shift = 0;
        for (var i = 0; i < half; i++) {
          shift += cards[i].offsetWidth + (parseFloat(getComputedStyle(cards[i]).marginRight) || 0);
        }
        track.style.setProperty('--drops-marquee-shift', Math.round(shift) + 'px');
      });
    }
    setMarqueeShift();
    window.addEventListener('load', setMarqueeShift);
    window.addEventListener('resize', setMarqueeShift);

    document.querySelectorAll('.drops-landing').forEach(function (root) {
      var form = root.querySelector('[data-drops-form]');
      if (!form) return;
      if (form.dataset.dropsBound === '1') return;
      form.dataset.dropsBound = '1';

      var input = form.querySelector('input[type="email"]');
      var submit = form.querySelector('[data-drops-submit]');
      var label = form.querySelector('[data-drops-label]');
      var feedback = form.querySelector('[data-drops-feedback]');
      var defaultFootnote = form.querySelector('[data-drops-default-footnote]');
      var shopNow = form.querySelector('[data-drops-shop-now]');
      var listId = root.getAttribute('data-klaviyo-list-id') || '';
      var originalLabel = label ? label.textContent.trim() : 'GET NOTIFIED';

      // Swap the form into "success" mode: hide the email input + submit
      // button, reveal the SHOP NOW link that points to the homepage.
      function showShopNow() {
        if (input) input.hidden = true;
        if (submit) submit.hidden = true;
        if (defaultFootnote) defaultFootnote.hidden = true;
        if (shopNow) shopNow.hidden = false;
      }

      function setFeedback(message, state) {
        if (!feedback) return;
        feedback.textContent = message;
        feedback.hidden = false;
        if (state) feedback.setAttribute('data-state', state);
        else feedback.removeAttribute('data-state');
      }

      function setSubmitting(busy) {
        if (!submit) return;
        submit.disabled = !!busy;
        if (label) label.textContent = busy ? 'SENDING…' : originalLabel;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!input) return;
        var email = (input.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setFeedback('Please enter a valid email address.', 'error');
          return;
        }
        if (!listId) {
          setFeedback('Sign-up is not configured yet. Try again later.', 'error');
          return;
        }

        setSubmitting(true);
        if (defaultFootnote) defaultFootnote.hidden = true;
        feedback.hidden = true;

        var body = new FormData();
        body.append('g', listId);
        body.append('email', email);

        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          body: body
        })
          .then(function (response) {
            return response.json().catch(function () { return {}; });
          })
          .then(function (data) {
            var ok = data && (data.success === true || data.data === true || data.success === 1);
            if (ok) {
              setFeedback("You're on the list — we'll be in touch.", 'success');
              if (input) input.value = '';
              showShopNow();
            } else {
              var msg = (data && (data.errors && data.errors[0] || data.message)) || 'Something went wrong. Please try again.';
              setFeedback(msg, 'error');
            }
          })
          .catch(function () {
            setFeedback('Network error. Please try again.', 'error');
          })
          .finally(function () {
            setSubmitting(false);
            // Restore the footnote only when we're still showing the form
            // (don't fight `showShopNow()` which hid it on success).
            if (defaultFootnote && shopNow && shopNow.hidden) {
              defaultFootnote.hidden = false;
            }
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.hasScrolled = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Check if user has scrolled (even a little) and add scrolled class
      if (scrollTop > 0 && !this.hasScrolled) {
        this.hasScrolled = true;
        this.classList.add('header-wrapper--scrolled');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      
      // Ensure border remains visible when header is hidden
      if (this.hasScrolled) {
        this.classList.add('header-wrapper--scrolled');
      }
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      
      // Ensure border shows when header becomes sticky
      if (this.hasScrolled) {
        this.classList.add('header-wrapper--scrolled');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
